import React, {Component} from "react";
import {Redirect} from 'react-router'
import {Grid, Row, Col, Nav, NavItem, Tab} from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import {withNamespaces} from "react-i18next";
import {DataRssFeeds} from "../../components/Middleware/DataRssFeeds";
import {StatsRssView} from "../../components/CustomStatsCard/StatsRssView";

class ListRssFeeds extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            renderActive: false,
            renderRemoved: false,
            lastUpdate: ""
        };
        this.handleTabSelect = this.handleTabSelect.bind(this)
    }

    componentDidMount() {

        let dt = new Date();
        let utcDate = dt.toUTCString();

        this.setState({
            renderActive: true,
            renderRemoved: false,
            lastUpdate: utcDate
        })


    }

    handleClick() {
        this.setState({
            redirect: true
        })
    }

    handleTabSelect(event) {

        let dt = new Date();
        let utcDate = dt.toUTCString();

        if (event === "active_rss") {
            this.setState({
                renderActive: true,
                renderRemoved: false,
                lastUpdate: utcDate
            })
        }
        if (event === "removed_rss") {
            this.setState({
                renderActive: false,
                renderRemoved: true,
                lastUpdate: utcDate
            })
        }
    }

    renderDataRssFeedsActive = () => {

        if (this.state.renderActive) {
            return (
                <DataRssFeeds
                    listName={this.props.t('rss_list.active_list', {framework: "react-i18next"})}
                    lastUpdate={""}
                    listState="active"/>
            );
        }

    }

    renderDataRssFeedsRemoved = () => {

        if (this.state.renderRemoved) {
            return (
                <DataRssFeeds
                    listName={this.props.t('rss_list.removed_list', {framework: "react-i18next"})}
                    lastUpdate={""}
                    listState="removed"/>
            );
        }
    }

    renderRedirect = () => {

        if (this.state.redirect) {
            let path = "/edit-rss/new";
            return <Redirect push to={path}/>
        }
    }

    render() {
        return (
            <div className="main-content">
                {this.renderRedirect()}
                <Grid fluid>
                    <StatsRssView/>
                    <Row>
                        <Col md={12}>
                            <Card
                                content={
                                    <Tab.Container id="nav-with-icons" defaultActiveKey="active_rss"
                                                   onSelect={this.handleTabSelect}>
                                        <div>
                                            <div className="nav-container">
                                                <Nav bsStyle="tabs" bsClass="nav nav-icons">
                                                    <NavItem eventKey="active_rss">
                                                        <i className="fa fa-bolt"/><br/> {this.props.t('global.active', {framework: "react-i18next"})}
                                                    </NavItem>
                                                    <NavItem eventKey="removed_rss">
                                                        <i className="fa fa-trash"/><br/> {this.props.t('global.removed', {framework: "react-i18next"})}
                                                    </NavItem>
                                                    <NavItem onClick={this.handleClick.bind(this)}>
                                                        <i className="fa fa-plus-circle"/><br/> {this.props.t('global.new', {framework: "react-i18next"})}
                                                    </NavItem>
                                                </Nav>
                                            </div>
                                            <Tab.Content>
                                                <Tab.Pane eventKey="active_rss">
                                                    {this.renderDataRssFeedsActive()}
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="removed_rss">
                                                    {this.renderDataRssFeedsRemoved()}
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </div>
                                    </Tab.Container>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default withNamespaces('common')(ListRssFeeds);